import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import {
    FaMedal,
    FaGraduationCap,
    FaChartLine,
    FaUniversity
} from 'react-icons/fa';

const CountUpAnimation = ({
    icon: Icon,
    initialValue,
    targetValue,
    text,
    suffix = '',
    prefix = ''
}) => {
    const [count, setCount] = useState(initialValue);
    const duration = 3000; // 3 seconds

    useEffect(() => {
        let startValue = initialValue;
        const increment = (targetValue - initialValue) / (duration / 50);

        const counter = setInterval(() => {
            startValue += increment;
            setCount(startValue);
            if (startValue >= targetValue) {
                clearInterval(counter);
                setCount(targetValue);
            }
        }, 50);

        return () => clearInterval(counter);
    }, [targetValue, initialValue]);

    return (
        <motion.div
            className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-center transform transition-all duration-300 hover:scale-105 hover:shadow-2xl"
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="text-yellow-300 text-4xl mb-4">
                <Icon />
            </div>
            <div className="text-white text-4xl font-bold mb-2">
                {prefix}{parseFloat(count.toFixed(2))}{suffix}
            </div>
            <div className="text-yellow-200 uppercase text-sm tracking-wider">
                {text}
            </div>
        </motion.div>
    );
};

const NumberAnimation = () => {
    const statsData = [
        {
            icon: FaMedal,
            initialValue: 0,
            targetValue: 48,
            text: "Highest Package",
            suffix: " LPA",
        },
        {
            icon: FaChartLine,
            initialValue: 0,
            targetValue: 5.48,
            text: "Average Package",
            suffix: " LPA",
        },
        {
            icon: FaUniversity,
            initialValue: 0,
            targetValue: 15,
            text: "Years of Excellence",
            prefix: "",
            suffix: "+",
        }
    ];

    return (
        <div className="bg-gradient-to-br from-[#0e4d38] to-[#145a46] py-16">
            <div className="container mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.7 }}
                >
                    <div className="text-center mb-12">
                        <h2 className="text-yellow-300 font-bold text-4xl uppercase mb-4">
                            Why Choose Maya Devi University? – Highlights of the Best University in Dehradun
                        </h2>
                        <p className="text-white max-w-2xl mx-auto text-lg">
                            Discover the outstanding achievements and key milestones that establish Maya Devi University as a top leader in education and the best university in Dehradun.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-8">
                        {statsData.map((stat, index) => (
                            <CountUpAnimation
                                key={index}
                                icon={stat.icon}
                                initialValue={stat.initialValue}
                                targetValue={stat.targetValue}
                                text={stat.text}
                                suffix={stat.suffix}
                                prefix={stat.prefix}
                            />
                        ))}
                    </div>

                    {/* <div className="text-center mt-12">
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            className="bg-gradient-to-br from-yellow-200 via-yellow-300 to-amber-300 text-[#0e4d38] px-8 py-3 rounded-full font-bold 
                            hover:bg-yellow-400 transition duration-300 transform"
                        >
                            Explore Our Achievements
                        </motion.button>
                    </div> */}
                </motion.div>
            </div>
        </div>
    );
}

export default NumberAnimation;